import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

const propTypes = {
  titleKey: PropTypes.string,
  customerId: PropTypes.string,
};

const SectionTitle = ({ customerId, titleKey }) => {
  if (customerId) {
    return (
      <div className="grid grid--bottom">
        <div className="grid__item three-quarters portable-one-whole">
          <div className="page-title-section">
            <h1 className="page-title">
              <FormattedMessage id={titleKey} />
            </h1>
            <span className="txt-muted">
              <FormattedMessage
                id="selfservice.profile.customerNumber"
                values={{
                  number: <span className="txt-base">{customerId}</span>,
                }}
              />
            </span>
          </div>
        </div>
      </div>
    );
  }
  return (
    <h1 className="page-title">
      <FormattedMessage id={titleKey} />
    </h1>
  );
};

SectionTitle.propTypes = propTypes;

export default SectionTitle;
